var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPen = function SvgPen(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3286 3.58579C16.1096 2.80474 17.3759 2.80474 18.157 3.58579L20.9854 6.41421C21.7664 7.19526 21.7664 8.46159 20.9854 9.24263L8.96457 21.2634C8.77619 21.4518 8.52041 21.5572 8.25399 21.5563L3.99653 21.5415C3.73131 21.5406 3.47731 21.4344 3.29043 21.2462C3.10354 21.058 2.99907 20.8033 3.00001 20.538L3.01485 16.3102C3.01578 16.0462 3.12106 15.7933 3.30774 15.6066L15.3286 3.58579ZM5.01339 16.7294L5.00351 19.545L7.84469 19.5549L19.5712 7.82842L16.7428 5L5.01339 16.7294Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.707 6.58575L17.9497 10.8284L17.2426 11.5355L12.9999 7.29286L13.707 6.58575Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPen);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pen.a5fe906ef3c815b23a8f7faedbf6e9c7.svg";